<template>
    <div class="setting-page-content-wrapper features">
        <div class="page-header">
            <div class="title">{{ $t("settings.auto_assign") }}</div>
            <div class="subtitle">{{ $t("settings.changeSettings") }}</div>
        </div>
        <section>
            <div class="features">
                <FeatureItem
                    :title="feature.title"
                    :description="feature.description"
                    v-for="feature in features"
                    :value="readValue(feature.id)"
                    @input="setValue(feature.id, $event)"
                    :key="feature.id"
                    :icon="feature.icon"
                    :type="feature.type"
                    :min="feature.min"
                    :max="feature.max"
                    :step="feature.step"
                />

                <FeatureItem
                    :title="$t('message.algorithm')"
                    icon="RoundRobin"
                    v-model="algorithm"
                    :description="$t('message.algo_desc')"
                    type="select"
                    :options="algorithms"
                    default-select-option-placeholder="Select an Algorithm"
                >
                    <div class="algorithms d-flex flex-column gap-5">
                        <div><b>Ordered</b>: {{ $t("message.ordered_desc") }}</div>
                        <div><b>Random</b>: {{ $t("message.random_desc") }}</div>
                        <div><b>Round Robin</b>: {{ $t("message.Rrobin_desc") }}</div>
                        <div><b>Round Robin Reverse</b>: {{ $t("message.RrobinRev_desc") }}</div>
                    </div>
                </FeatureItem>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../../utils/log2";
import WirelessKeyboardIcon from "../../../../../components/svg/icons/WirelessKeyboardIcon.vue";
import FeatureItem from "../../components/FeatureItem.vue";
import * as _ from "lodash";

const log = log2("Settings/AutoChatAssign");

export default {
    name: "AutoChatAssign",
    components: {
        WirelessKeyboardIcon,
        FeatureItem,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            features: [
                {
                    title: this.$t("message.autoCallTransfer"),
                    description: this.$t("message.vtipyAutoCallTransfer"),
                    icon: "automaticCallTransfer",
                    id: "autoTake",
                },
                {
                    title: this.$t("message.forceQueueForNoOwnerContacts"),
                    description: this.$t("message.forceQueueDescription"),
                    icon: "automaticCallTransfer",
                    id: "autoAssignForcesQueueNoOwnerContacts",
                },
                {
                    title: this.$t("message.autoForwardToOwnerForce"),
                    description: this.$t("message.autoForwardToOwnerForceDescription"),
                    icon: "automaticCallTransfer",
                    id: "autoForwardToOwnerForce",
                },
                {
                    title: this.$t("message.showNoOwnerContactsToAdmins"),
                    description: this.$t("message.showNoOwnerContactsDescription"),
                    icon: "automaticCallTransfer",
                    id: "onlyAdminsShowsNoOwnerContacts",
                },
                {
                    title: this.$t("message.autoAssignOwner"),
                    description: this.$t("message.autoAssignOwnerDescription"),
                    icon: "automaticCallTransfer",
                    id: "autoAssignOwner",
                },
                {
                    title: this.$t("message.autoAssignLimit"),
                    description: this.$t("message.vtipyAutoAssignLimit"),
                    icon: "AutoLimitIcon",
                    id: "autoAssignDefaultLimit",
                    min: 0,
                    max: 999999999,
                    step: 1,
                    type: "number",
                },
            ],
            algorithms: [
                {
                    id: "ordered",
                    label: "Ordered",
                },
                {
                    id: "random",
                    label: "Random",
                },
                {
                    id: "round-robin",
                    label: "Round Robin",
                },
                {
                    id: "round-robin-reverse",
                    label: "Round Robin Reverse",
                },
            ],
        };
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
        algorithm: {
            get() {
                return _.get(this.settings, "autoAssignAlgorithm");
            },
            set(value) {
                this.updateSettings("autoAssignAlgorithm", value);
            },
        },
    },
    methods: {
        readValue(id) {
            log("readValue", id, this.settings[id]);
            if (["customerClientLanguageDetect", "subject", "autoTake", "writing", "bannedWord"].includes(id)) {
                return this.settings[id] == true;
            } else {
                return this.settings[id];
            }
        },
        setValue(id, value) {
            this.updateSettings(id, value);
        },
    },
    mounted() {},
    watch: {},
};
</script>

<style scoped lang="scss">
.features {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>
